<template>
  <v-dialog
    :value="value"
    max-width="560"
    persistent
    overlay-opacity="0.72"
    content-class="bug-report-dialog"
    @input="$emit('input', $event)"
  >
    <v-card class="bug-report-card">
      <div class="bug-report-hero">
        <div class="bug-report-icon">
          <v-icon color="primary">mdi-bug-outline</v-icon>
        </div>
        <div>
          <div class="bug-report-title">Reportar problema</div>
          <div class="bug-report-subtitle">
            Cuéntanos qué pasó y el equipo de sistemas lo revisará.
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon small :disabled="loading" aria-label="Cerrar reporte" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="bug-report-body">
        <v-alert
          dense
          text
          color="blue"
          icon="mdi-shield-check-outline"
          class="mb-4"
        >
          No necesitas capturas. Evita escribir contraseñas o datos sensibles.
        </v-alert>

        <div class="bug-section-label">¿Qué ocurrió?</div>
        <v-textarea
          v-model="form.descripcion_usuario"
          placeholder="Ej. Al guardar el formulario apareció un error y no se registró el cambio."
          outlined
          auto-grow
          rows="5"
          counter="2000"
          hide-details="auto"
          :rules="[rules.descripcion]"
          class="bug-textarea"
        />
      </v-card-text>

      <v-card-actions class="bug-report-actions">
        <v-spacer></v-spacer>
        <v-btn text :disabled="loading" class="mr-2" @click="close">Cancelar</v-btn>
        <v-btn
          color="primary"
          depressed
          large
          :loading="loading"
          :disabled="!puedeEnviar"
          @click="submit"
        >
          <v-icon left small>mdi-send</v-icon>
          Enviar reporte
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { crearBugReport } from '@/api/bugReports'

export default {
  name: 'BugReportDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    context: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    loading: false,
    form: {
      descripcion_usuario: '',
    },
    rules: {
      descripcion: (v) => !v || String(v).length <= 2000 || 'Máximo 2000 caracteres',
    },
  }),

  computed: {
    puedeEnviar() {
      const descripcion = String(this.form.descripcion_usuario || '').trim()
      const errorMessage = this.context && this.context.error && this.context.error.message
      return descripcion.length > 0 || !!errorMessage
    },
  },

  watch: {
    value(open) {
      if (open) {
        const msg = this.context && this.context.error && this.context.error.message
          ? String(this.context.error.message).trim()
          : ''
        this.form.descripcion_usuario = msg
          ? `Vi este error en el sistema:\n${msg}\n\nDetalle adicional: `
          : ''
      }
    },
  },

  methods: {
    close(force = false) {
      if (this.loading && !force) return
      this.form.descripcion_usuario = ''
      this.$emit('input', false)
    },

    async submit() {
      if (!this.puedeEnviar) return

      this.loading = true
      try {
        const payload = {
          ...this.context,
          severidad: 'media',
          descripcion_usuario: String(this.form.descripcion_usuario || '').trim(),
        }
        const response = await crearBugReport(payload)
        const id = response && response.data ? response.data.id : null
        this.$notify({
          group: 'foo',
          title: 'Reporte registrado',
          text: id ? `Tu reporte fue registrado #${id}` : 'Tu reporte fue registrado.',
          type: 'success',
        })
        this.close(true)
      } catch (error) {
        const message = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'No fue posible registrar el reporte.'
        this.$notify({
          group: 'foo',
          title: 'Reporte de problema',
          text: message,
          type: 'error',
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.bug-report-card {
  border-radius: 18px;
  overflow: hidden;
  background: #ffffff;
}

.bug-report-hero {
  align-items: center;
  background:
    radial-gradient(circle at 12% 20%, rgba(59, 130, 246, 0.16), transparent 34%),
    linear-gradient(135deg, #f8fbff 0%, #eef6ff 58%, #fff7ed 100%);
  border-bottom: 1px solid #e5eefb;
  color: #172033;
  display: flex;
  gap: 14px;
  padding: 22px 24px;
}

.bug-report-icon {
  align-items: center;
  background: #ffffff;
  border: 1px solid #dbeafe;
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(37, 99, 235, 0.12);
  display: flex;
  height: 46px;
  justify-content: center;
  width: 46px;
}

.bug-report-title {
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.bug-report-subtitle {
  color: #64748b;
  font-size: 14px;
  margin-top: 2px;
}

.bug-report-body {
  background: #ffffff;
  padding: 24px 24px 8px;
}

.bug-section-label {
  color: #1f2937;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.bug-textarea {
  border-radius: 14px;
}

.bug-report-actions {
  background: #ffffff;
  border-top: 1px solid #eef2f7;
  padding: 16px 24px 24px;
}
</style>
